// extracted by mini-css-extract-plugin
export var bubble = "fRQG_5RDyR1Z1vox44k2";